import { css } from "@emotion/react"
import { containerWidth, baseFontSize } from "@mkt/ui/styles/Variables"
import { above, below } from "@mkt/ui/styles/Breakpoints"

export const container = css`
  padding: 0 16px;

  ${above["l"]} {
    max-width: ${containerWidth};
    margin: 0 auto;
  }

  ${below["m"]} {
    width: 100%;
  }
`

export const getDuration = (i, start = 0.09) => `${0.32 + i * start}s`

export const toRem = (value) => {
  if (!value) return
  const number = baseFontSize.replace("px", "")
  const cleanValue = String(value).replace("px", "")
  const rem = (1 / number) * cleanValue + "rem"

  return rem
}

export const arcuiro = css`
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(222, 61, 181, 1) 65%,
    rgba(64, 137, 237, 1) 100%
  );
`
